export default {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "authorization" */'../../views/Authorization.vue')
};
